/**
* Product Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Product Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger )
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'product-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.product-grid' ).length ) {
        $( '.product-grid__slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.product-grid' ).each( function( index, element ) {
          new Splide( element, {
            gap: '1rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'product-grid', COMPONENT );
} )( app );
